// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index_room__37y0tt0Q{height:300px;overflow:hidden;border:1px solid #ccc}", ""]);
// Exports
exports.locals = {
	"room": "index_room__37y0tt0Q"
};
module.exports = exports;
